var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "battery-order-history-view__container battery-order-history-view__container--history"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "battery-order-view__row battery-order-view__row--title"
          },
          [_vm._v("\n      Order History\n    ")]
        ),
        _vm._v(" "),
        _vm.orders.length
          ? _c(
              "div",
              {
                staticClass:
                  "battery-order-view__container battery-order-view__container--order"
              },
              [
                _c("OrderHeader"),
                _vm._v(" "),
                _vm._l(_vm.orders, function(order, index) {
                  return _c("Order", {
                    key: index,
                    attrs: { index: index, order: order }
                  })
                })
              ],
              2
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }